var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.33301 9.99984C3.33301 8.15889 4.82539 6.6665 6.66634 6.6665L33.333 6.66651C35.174 6.66651 36.6663 8.15889 36.6663 9.99984L36.6663 14.9998C36.6663 15.9203 35.9201 16.6665 34.9997 16.6665L4.99967 16.6665C4.0792 16.6665 3.33301 15.9203 3.33301 14.9998L3.33301 9.99984ZM33.333 9.99984L6.66634 9.99984L6.66634 13.3332L33.333 13.3332L33.333 9.99984Z",
    fill: "#7F67BE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.33301 15.0002C3.33301 14.0797 4.0792 13.3335 4.99967 13.3335L34.9997 13.3335C35.9201 13.3335 36.6663 14.0797 36.6663 15.0002L36.6663 35.0002C36.6663 35.9206 35.9201 36.6668 34.9997 36.6668L4.99967 36.6668C4.0792 36.6668 3.333 35.9206 3.333 35.0002L3.33301 15.0002ZM6.66634 16.6668L6.66634 33.3335L33.333 33.3335L33.333 16.6668L6.66634 16.6668Z",
    fill: "#7F67BE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99967 3.3335C10.9201 3.3335 11.6663 4.07969 11.6663 5.00016L11.6663 6.66683C11.6663 7.5873 10.9201 8.33349 9.99967 8.33349C9.0792 8.33349 8.33301 7.5873 8.33301 6.66683L8.33301 5.00016C8.33301 4.07969 9.0792 3.3335 9.99967 3.3335Z",
    fill: "#7F67BE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.9997 3.3335C20.9201 3.3335 21.6663 4.07969 21.6663 5.00016L21.6663 6.66683C21.6663 7.5873 20.9201 8.33349 19.9997 8.33349C19.0792 8.33349 18.333 7.5873 18.333 6.66683L18.333 5.00016C18.333 4.07969 19.0792 3.3335 19.9997 3.3335Z",
    fill: "#7F67BE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.9997 3.3335C30.9201 3.3335 31.6663 4.07969 31.6663 5.00016L31.6663 6.66683C31.6663 7.5873 30.9201 8.33349 29.9997 8.33349C29.0792 8.33349 28.333 7.5873 28.333 6.66683L28.333 5.00016C28.333 4.07969 29.0792 3.3335 29.9997 3.3335Z",
    fill: "#7F67BE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28.333 20L31.6663 20L31.6663 23.3333L28.333 23.3333L28.333 20Z",
    fill: "#7F67BE"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21.667 26.6665L25.0003 26.6665L25.0003 29.9998L21.667 29.9998L21.667 26.6665Z",
    fill: "#7F67BE"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M21.667 20L25.0003 20L25.0003 23.3333L21.667 23.3333L21.667 20Z",
    fill: "#7F67BE"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M15 26.6665L18.3333 26.6665L18.3333 29.9998L15 29.9998L15 26.6665Z",
    fill: "#7F67BE"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M15 20L18.3333 20L18.3333 23.3333L15 23.3333L15 20Z",
    fill: "#7F67BE"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M8.33301 26.6665L11.6663 26.6665L11.6663 29.9998L8.33301 29.9998L8.33301 26.6665Z",
    fill: "#7F67BE"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.5b25b7477cdf7dfa60c9de2caf22133e.svg";
export { ForwardRef as ReactComponent };